import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { Layout } from "./components/Layout";
import { EmptyState, Spinner } from "./components/States";
import { cloudSyncEnabled } from "./config";
import { HomePage } from "./features/home/HomePage";
import { LibraryProvider } from "./library/LibraryProvider";
import { PreferencesProvider } from "./preferences/PreferencesProvider";

// Rutas secundarias en chunks propios: la portada carga lo minimo.
const SearchPage = lazy(() => import("./features/search/SearchPage").then((m) => ({ default: m.SearchPage })));
const DetailPage = lazy(() => import("./features/detail/DetailPage").then((m) => ({ default: m.DetailPage })));
const PlayerPage = lazy(() => import("./features/player/PlayerPage").then((m) => ({ default: m.PlayerPage })));
const LibraryPage = lazy(() => import("./features/library/LibraryPage").then((m) => ({ default: m.LibraryPage })));
const SettingsPage = lazy(() => import("./features/settings/SettingsPage").then((m) => ({ default: m.SettingsPage })));
const AccountPage = lazy(() => import("./features/account/AccountPage").then((m) => ({ default: m.AccountPage })));

// Misma politica que la app: lo ya visto se muestra al instante y se revalida en segundo plano.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5 * 60_000, gcTime: 30 * 60_000, retry: 1, refetchOnWindowFocus: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PreferencesProvider>
        <AuthProvider>
          <LibraryProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Suspense fallback={<Spinner />}>
                <Routes>
                  <Route element={<Layout />}>
                    <Route index element={<HomePage />} />
                    <Route path="search" element={<SearchPage />} />
                    <Route path="anime" element={<DetailPage />} />
                    <Route path="watch" element={<PlayerPage />} />
                    <Route path="library" element={<LibraryPage />} />
                    <Route path="settings" element={<SettingsPage />} />
                    {cloudSyncEnabled && <Route path="account" element={<AccountPage />} />}
                    <Route path="*" element={<EmptyState message="Página no encontrada." />} />
                  </Route>
                </Routes>
              </Suspense>
            </BrowserRouter>
          </LibraryProvider>
        </AuthProvider>
      </PreferencesProvider>
    </QueryClientProvider>
  );
}
